<template>

  <ul v-if="elements.length > 0" class="pagenav">

    <!-- Previous Page Button -->
    <li v-if="meta.current_page === 1" class="pagenav__item">
      <a class="pagenav__link disabled" title="Previous">
        <img alt="" class="pagenav__prev" src="/shop/images/pagenav-arrow.svg">
      </a>
    </li>
    <li v-else class="pagenav__item">
      <a class="pagenav__link" title="Previous" @click="previousPage">
        <img alt="" class="pagenav__prev" src="/shop/images/pagenav-arrow.svg">
      </a>
    </li>

    <!-- Pagination Elements -->
    <template v-for="element in elements" :key="element">
      <li :title="meta.current_page" class="pagenav__item">
        <a :class="['pagenav__link', {'active': element === meta.current_page }]" @click="changePage(element)">
          {{ element }}
        </a>
      </li>
    </template>

    <!-- Next Page Button -->
    <li v-if="links.next" class="pagenav__item">
      <a class="pagenav__link" title="Next" @click="nextPage">
        <img alt="" class="pagenav__next" src="/shop/images/pagenav-arrow.svg">
      </a>
    </li>
    <li v-else class="pagenav__item">
      <a class="pagenav__link disabled" title="Next" @click="nextPage">
        <img alt="" class="pagenav__next" src="/shop/images/pagenav-arrow.svg">
      </a>
    </li>
  </ul>
</template>

<script>
import {pagination} from '../../helpers/pagination';

export default {
  name:     "catalogPagination",
  props:    [
    'meta',
    'links'
  ],
  emits:    [
    'change-page',
  ],
  computed: {
    /**
     * Compute the pagination elements based on the current and last page.
     */
    elements() {
      return pagination(this.meta.current_page, this.meta.last_page);
    }
  },
  methods:  {
    /**
     * Handle a click on a specific page.
     * @param {number} page - The page number to navigate to.
     */
    changePage(page) {
      this.$emit('change-page', page);
    },
    /**
     * Handle a click on the previous page button.
     */
    previousPage() {
      if (this.meta.current_page > 1) {
        this.changePage(this.meta.current_page - 1);
      }
    },
    /**
     * Handle a click on the next page button.
     */
    nextPage() {
      if (this.links.next) {
        this.changePage(this.meta.current_page + 1);
      }
    }
  }
};
</script>
